<template>
  <div>
    <UserLoginController
      v-if="isIdentityFirstFlow"
      :clientType="clientType"
      :context="context"
      :mfaType="mfaType"
      :paramError="error"
      :redirectTo="completeRedirectUrl"
      :step="step"
    />
    <ContextLogin
      v-else
      :class="['oauthCardContextLogin']"
      :redirectTo="redirectTo"
      :context="context"
      :clientType="clientType"
      :completeRedirectUrl="completeRedirectUrl"
    />
  </div>
</template>

<script>
import { UserRoutes } from 'client/routes/RouteGenerator';
import { useFeatureFlags } from 'client/stores/FeatureFlag';
import ContextLogin from 'client/containers/Login/ContextLogin.vue';
import UserLoginController from 'client/containers/user/UserLoginController.vue';

export default {
  name: 'OauthLoginWrapper',

  props: {
    clientType: {
      type: String,
      required: true,
    },
    context: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    mfaType: {
      type: String,
      default: '',
    },
    redirectTo: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '',
    },
  },
  components: {
    ContextLogin,
    UserLoginController,
  },

  /*
  * Code to display UserLoginController for Identity First
  * @todo Remove this code and ContextLogin component
  * in template once the feature flag goes to production
  */
  setup() {
    const { isIdentityFirstFlow } = useFeatureFlags();
    return { isIdentityFirstFlow };
  },

  data() {
    return {
      completeRedirectUrl: UserRoutes.oauthRedirectUrl(this.redirectTo),
    };
  },
};
</script>

<style scoped module>
@import '../../css/login-components.css';
</style>
